module.exports = __webpack_public_path__ + "img/055.991720a8.png";